// extracted by mini-css-extract-plugin
module.exports = {"static-content":"static-page_component_static-content__uzA3R"};